<template>
  <div>
    <Title
      title="Planificar por Sectores"
      subtitle="Crea, sectoriza y configura tus rutas"/>
    <div v-if="planningTracker === null">
      <el-row :gutter="30">
        <el-col>
          <ConfigPanel :data="dataToConfig"
                       :valid="extraDataValid"
                       @apply="applyConfiguration"/>
        </el-col>
        <el-col :md="10">
          <ExtraData v-model="extraData"
                     @errors="getExtraDataErrors"/>
        </el-col>
        <el-col :md="14">
          <SectorMap :points="dataToMap"/>
        </el-col>
        <el-col>
          <SectorList v-model="sectors"
                      :newCount="countSector"
                      @errors="getSectorErrors"/>
        </el-col>
        <el-col>
          <PlanningCheck :sectors="sectorErrors"
                         :suborders="suborderErrors"
                         :extraData="extraDataErrors"
                         @validPlanning="getValidation"/>
        </el-col>
        <el-col>
          <SuborderList v-model="suborders"
                        :sectors="sectorsToSoc"
                        :dataToGetTO="dataToGetTO"
                        @updateCode="updateCode"
                        @errors="getSuborderErrors"
                        @countSocWithoutSector="getCountSocWithoutSector"/>
        </el-col>
        <el-col>
          <PlanningSend :sectors="sectorList"
                        :extraData="extraData"
                        :historyCode="historyCode"
                        :validPlanning="checkedPlanning"
                        :countSocWithoutSector="countSocWithoutSector"
                        @success="successPlanning"/>
        </el-col>
      </el-row>
    </div>
    <el-row v-else>
      <el-col>
        <PlanningSuccess :planningTracker="planningTracker"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import SectorMap from '../components/planningv4/sector/Map.vue';
import SectorList from '../components/planningv4/sector/List.vue';
import ConfigPanel from '../components/planningv4/config/Panel.vue';
import PlanningSend from '../components/planningv4/general/Send.vue';
import SuborderList from '../components/planningv4/suborder/List.vue';
import ExtraData from '../components/planningv4/general/ExtraData.vue';
import PlanningCheck from '../components/planningv4/general/Check.vue';
import PlanningSuccess from '../components/planningv4/general/Success.vue';

export default {
  name: 'PlanningV4',
  components: {
    Title,
    ExtraData,
    SectorMap,
    SectorList,
    ConfigPanel,
    SuborderList,
    PlanningSend,
    PlanningCheck,
    PlanningSuccess,
  },
  data() {
    return {
      sectors: [],
      extraData: {},
      suborders: [],
      countSector: 0,
      historyCode: '',
      sectorErrors: [],
      suborderErrors: [],
      extraDataErrors: [],
      planningTracker: null,
      checkedPlanning: false,
      countSocWithoutSector: 0,
    };
  },
  mounted() {
  },
  methods: {
    updateCode(code) {
      this.historyCode = code;
    },
    successPlanning(id) {
      this.planningTracker = id;
    },
    getValidation(validation) {
      this.checkedPlanning = validation;
    },
    getExtraDataErrors(data) {
      this.extraDataErrors = data;
    },
    getSuborderErrors(data) {
      this.suborderErrors = data;
    },
    getSectorErrors(data) {
      this.sectorErrors = data;
    },
    getCountSocWithoutSector(count) {
      this.countSocWithoutSector = count;
    },
    applyConfiguration(config) {
      Object.entries(config).forEach(([k, v]) => {
        if (k === 'alg_settings') {
          Object.entries(config.alg_settings).forEach(([k2, v2]) => {
            this.extraData.alg_settings[k2] = v2;
          });
        } else if (k !== 'planBy' && k !== 'sectors') {
          this.extraData[k] = v;
        }
      });
      if (config.sectors.length > 0) {
        this.sectors = config.sectors;
        this.sectors.forEach((s) => {
          // eslint-disable-next-line no-param-reassign
          if (!s.mode) s.mode = 'LOCALIDAD';
        });
        this.countSector = config.sectors.length;
      }
      this.$notify({
        title: 'Configuración aplicada',
        type: 'success',
      });
    },
    filterMe(arr, el, equal) {
      return equal ? arr.filter(l => l === el) : arr.filter(l => l !== el);
    },
  },
  computed: {
    dataToGetTO() {
      return {
        ct: this.extraData.ct,
        date: this.extraData.time_init,
      };
    },
    dataToConfig() {
      return Object.assign({},
        this.extraData,
        {
          sectors: this.sectors.map((s, index) => ({
            id: index + 1,
            mode: s.mode,
            name: s.name,
            pinned: true,
            suborders: [],
            color: s.color,
            region: s.region,
            polygon: s.polygon,
            vehicles: s.vehicles,
            localities: s.localities,
            enterprise: s.enterprise,
            packageTypes: s.packageTypes,
            maximumPrice: s.maximumPrice,
            maximumVolume: s.maximumVolume,
          })),
        });
    },
    dataToMap() {
      // [{"price":20900,"volume":0.000052,"lat":-33.24762389,"lng":-33.24762389,]
      return this.sectors.filter(s => s.suborders.length > 0 && s.pinned)
        .map((sector) => {
          const socs = this.suborders
            .filter(soc => soc.sectors.length > 0 && soc.sectors[0].id === sector.id);
          return { color: sector.color, points: socs.map(s => ({ lat: s.lat, lng: s.lng })) };
        });
    },
    extraDataValid() {
      return this.extraDataErrors.length === 0;
    },
    sectorsToSoc() {
      return this.sectors
        .map(s => ({
          id: s.id,
          name: s.name,
          mode: s.mode,
          color: s.color,
          polygon: s.polygon,
          localities: s.localities,
          packageTypes: s.packageTypes,
        }));
    },
    sectorList() {
      return this.sectors.map((sector) => {
        const socs = this.suborders
          .filter(soc => soc.sectors.length > 0 && soc.sectors[0].id === sector.id);
        const currentVolume = socs.reduce((acum, el) => acum + el.volume, 0);
        const currentPrice = socs.reduce((acum, el) => acum + el.price, 0);
        const suborders = socs.map(s => s.suborder);
        const socRedStatus = socs.filter(s => [5, 6].includes(s.last_state)).length;
        let localities = socs.filter(s => s.locality !== '').map(s => s.locality);
        const topLocalities = [];
        while (localities.length > 0) {
          const count = this.filterMe(localities, localities[0], true).length;
          topLocalities.push([localities[0], count]);
          localities = this.filterMe(localities, localities[0], false);
        }
        topLocalities.sort((a, b) => (a[1] > b[1] ? -1 : 1)).splice(3);
        return Object.assign(sector, {
          suborders, topLocalities, currentVolume, currentPrice, socRedStatus,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-col { padding-bottom: 35px; }
</style>
